<template>
  <el-pagination class="XJ-pagination-wrap" :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout" :page-sizes="pageSizes" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'

export default {
  name: "pagination",
  props: {
    // eslint-disable-next-line vue/require-default-prop
    total: {
      required: false,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 30
    },
    pageSizes: {
      type: Array,
      default() {
        return [30, 50, 70, 100];
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("changelist", { current: this.page, size: val });
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    },
    handleCurrentChange(val) {
      this.$emit("changelist", { current: val, size: this.limit });
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
  /deep/.el-pager li.active {
    border: 1px solid #ca691c;
  }
</style>
<style lang="scss">
  .XJ-pagination-wrap.el-pagination.is-background .btn-prev,
  .XJ-pagination-wrap.el-pagination.is-background .btn-next,
  .XJ-pagination-wrap.el-pagination.is-background .el-pager li {
    background-color: #fff;
  }
</style>
